export enum TodoListTaskStatus {
  ToDo = 0,
  Done = 100,
}
